import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloRecuperoCreditiStragiudiziale extends FascicoloFull {
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
